import {Component, Input} from "@angular/core";
import {OrderingContextModel} from "../../ordering-context/ordering-context.model";
import {StoreData, StoreDisplayStatus} from "../store-search.model";
import {OrderType} from "../../order/order";

@Component({
    selector: "woa-store-status-panel",
    templateUrl: "./store-status-panel.component.html"
})
export class StoreStatusPanelComponent {
    @Input() store: StoreData;
    @Input() filteredOrderType: OrderType;

    public showHours: boolean = false;

    constructor(public orderingContextModel: OrderingContextModel) {
    }

    daysOfWeek: string[] = [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday"
    ];

    get isOpen(): boolean {
        const displayStatus: StoreDisplayStatus = this.displayStatus;
        return displayStatus === StoreDisplayStatus.CURRENTLY_OPEN || displayStatus === StoreDisplayStatus.OPEN_AT_TIME;
    }

    get statusLabel(): string {
        switch (this.displayStatus) {
            case StoreDisplayStatus.OFFLINE: return "woa.label.store-status.offline";
            case StoreDisplayStatus.CURRENTLY_CLOSED: return "woa.label.store-status.currentlyClosed";
            case StoreDisplayStatus.CLOSED_AT_TIME: return "woa.label.store-status.closedAtTime";
            case StoreDisplayStatus.CURRENTLY_OPEN: return "woa.label.store-status.currentlyOpen";
            case StoreDisplayStatus.OPEN_AT_TIME: return "woa.label.store-status.openAtTime";
        }
    }

    get displayStatus(): StoreDisplayStatus {
        return this.store ? this.store.getDisplayStatus(this.filteredOrderType || this.orderingContextModel.orderType) : undefined;
    }

    toggleHours(hours: HTMLElement): void {
        this.showHours = !this.showHours;
        hours.style.maxHeight = this.showHours ? hours.scrollHeight + "px" : "0";
    }
}



// WEBPACK FOOTER //
// ./src/app/store/store-status-panel/store-status-panel.component.ts